import { Button, Rate, Skeleton } from 'antd';
import moment from 'moment';
import { FC, useState } from "react";
import { Col, Row } from 'reactstrap';
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { getCourseReviewByPage } from '@/actions/courses';
import { capitalizeFirstLetter } from '@/helpers/dataHelper';
import AvatarComponent from '../../../common/avatar';
import ReadMore from '../../../common/read-more';
import LikeDislike from './liked-dislike';
import { isLogin } from '@/helpers/loginHelper';
import useWidth, { IBooleanArgs } from '@/helpers/widthUtil';
import { Dispatch } from 'redux';

type CourseReviewProps = {
  courseReview: object | any;
  courseSlug: string;
  reviewRef?: any;
};

const CourseReview: FC<CourseReviewProps> = ({
  courseReview,
  courseSlug,
  reviewRef,
}) => {
  const { isGalaxyZFold }: IBooleanArgs = useWidth();
  const skeleton: Array<number> = [1];
  const dispatch: Dispatch = useDispatch();
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(5);

  const metaData = useSelector(
    (state: RootStateOrAny) => state.courses?.courseReview?.meta
  );
  const reviewLoading = useSelector(
    (state: RootStateOrAny) => state.courses?.courseReview
  );
  const viewMoreReview = (): void => {
    if (pageNumber < metaData.last_pages) {
      dispatch(getCourseReviewByPage(courseSlug, pageNumber + 1, perPage));
      setPageNumber(pageNumber + 1);
      setPerPage(perPage + 5);
    }
  };

  return (
    <div>
      {reviewLoading?.loading ? (
        <>
          {skeleton.map((data: any, index: number) => (
            <Skeleton key={index} avatar paragraph={{ rows: 8 }} />
          ))}
        </>
      ) : (
        <Row>
          <Col md="12">
              <div className="review-comments" ref={reviewRef}>
              {courseReview?.data?.map((review: object | any) => {
                return (
                  <div key={review?.id}>
                    <div
                      className="comment-box bg-light mb-4 d-flex p-3 border-14"
                    >
                      {!isGalaxyZFold && (
                        <div className="comment-image">
                          <AvatarComponent
                            avatar={review?.review_by?.avatar}
                            firstName={review?.review_by?.first_name}
                            lastName={review?.review_by?.last_name}
                            size="large"
                            className={'mt-1'}
                          />
                        </div>
                      )}
                      <div
                        className={`comment-content ${!isGalaxyZFold ? 'ml-3' : ''}`}
                      >
                        <div className="content-title d-flex justify-content-between">
                          <div className="comment-writer">
                            <div className="d-flex justify-content-between">
                              <h4
                                className="font-weight-normal mt-2 text-muted text-wrap"
                                style={{ fontSize: isGalaxyZFold ? '12px' : '16px' }}
                              >
                                {capitalizeFirstLetter(
                                  review?.review_by?.first_name
                                )}{' '}
                                {capitalizeFirstLetter(review?.review_by?.last_name)}
                              </h4>
                              {isLogin() ? (
                                <LikeDislike
                                  liked={review?.liked}
                                  disliked={review?.disliked}
                                  id={review?.id}
                                  likeCount={review?.like_count}
                                  dislikeCount={review?.dislike_count}
                                />
                              ) : (
                                ''
                              )}
                            </div>
                            <div className="d-flex justify-content-between">
                              <p>
                                <Rate
                                  style={{ fontSize: '14px', color: '#FABB02' }}
                                  disabled
                                  defaultValue={review?.course_rating}
                                />
                              </p>
                              <p className="text-muted font-weight-normal ml-2">
                                {moment(review?.updated_at).fromNow()}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="comment-desc">
                          <ReadMore text={review?.feedback} />
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            {courseReview?.data.length > 0 ? (
              metaData?.current_page == metaData?.last_pages ? (
                ''
                ) : (
                <div className="text-center">
                  <Button
                    className="btn-secondary border-danger"
                    loading={reviewLoading?.moreLoading}
                    onClick={viewMoreReview}
                  >
                    View More Reviews
                  </Button>
                </div>
              )
            ) : (
              ''
              )}
          </Col>
        </Row>
      )}
    </div>
  );
};

export default CourseReview;
